import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import {
    ACTION_TYPES,
    API_ACTION_TYPES,
    createAction,
    FETCH_STATUS,
    SELECTORS,
    useFetchStatus,
} from "@Utils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePlanDropdownBaseProps } from "../../../utils/plan";

export const useFetchPlanData = ({
    urlQueryParams,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => {
    const dispatch = useDispatch();
    const host = useSelector(SELECTORS.host);
    const hostName = useSelector(SELECTORS.hostName);

    const { planId, planListings } = usePlanDropdownBaseProps({
        urlQueryParams,
    });

    const planFetchStatus = useFetchStatus(API_ACTION_TYPES.FETCH_PLAN_DETAILS);

    useEffect(() => {
        if (
            planId &&
            (planFetchStatus === FETCH_STATUS.NOT_FETCHED ||
                (planFetchStatus === FETCH_STATUS.FETCHED &&
                    !(planId in host?.plans?.details)))
        ) {
            dispatch(
                createAction(ACTION_TYPES.UTILS.API_CALL, {
                    apiActionType: API_ACTION_TYPES.FETCH_PLAN_DETAILS,
                    urlArgs: {
                        planId,
                        subDomain: hostName,
                    },
                })
            );
        }
    }, [planFetchStatus, planId, planListings]);
};
